export const PROPERTY_TYPES = [
  { value: 'all', label: 'All Types' },
  { value: 'Residential', label: 'Residential' },
  { value: 'Multi-Family', label: 'Multi-Family' },
  { value: 'Commercial Sale', label: 'Commercial Sale' },
  { value: 'Commercial Lease', label: 'Commercial Lease' },
  { value: 'Farm', label: 'Farm' },
  { value: 'Land', label: 'Land' },
  { value: 'Residential Lease', label: 'Residential Lease' },
  { value: 'Business Opportunity', label: 'Business Opportunity' },
];

export const STATUS_OPTIONS = [
  { value: 'all', label: 'All Status' },
  { value: 'Active', label: 'Active' },
  { value: 'Pending', label: 'Pending' },
  { value: 'Closed', label: 'Closed' },
  { value: 'Expired', label: 'Expired' },
  { value: 'Withdrawn', label: 'Withdrawn' },
  { value: 'Coming Soon', label: 'Coming Soon' },
];

export const PER_PAGE_OPTIONS = [
  { value: 8, label: '8 per page' },
  { value: 12, label: '12 per page' },
  { value: 20, label: '20 per page' },
  { value: 50, label: '50 per page' },
  { value: 100, label: '100 per page' },
];
